module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 18
// module chunks = 0